import React, { useEffect, useState } from "react";
import { ChevronLeft, GeoAltFill, CurrencyRupee } from "react-bootstrap-icons";
import { decryptData } from "../../utils/crypto";
import { getAllCustomerConfigList } from "../../services/customerServices";
import Utils from "../../utils";
import { useTranslation } from "react-i18next";
import { formatCurrencyINR } from "../../utils/function";
import { createOrderStoreOwner } from "../../services/storeOwnerOrderServices";
import { notify } from "../../components/Common/Alerts";
import { useConfig } from "../../components/Context/ConfigContext";

const StoreOwnerOrderSummary = ({
  cart,
  customerData,
  setOrderModel,
  setCart,
  setCustomerData,
}) => {
  const { t } = useTranslation();
  const { configData } = useConfig();

  const [orderType, setOrderType] = useState(1);
  const [configList, setConfigList] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [formsData, setFormsData] = useState({
    full_address: "",
    paid_amount: "",
    latitude: "",
    longitude: "",
  });
  const [paymentmethod, setPaymentMethod] = useState("");
  const [placeOrderModel, setPlaceOrderModel] = useState(false);
  const [errors, setErrors] = useState({
    paid_amount: "",
    payment_method: "",
    full_address: "",
  });

  const validateField = (name, value, totalPrice) => {
    switch (name) {
      case "paid_amount":
        if (Number(paymentmethod) === 0) {
          return "";
        }

        if (value === "" || value === null || value === undefined)
          return t("amountIsRequired");

        // if (Number(value) > Number(totalPrice))
        //   return t("paidAmountCannotBeGreaterThanTotal");

        return "";

      case "payment_method":
        if (formsData?.paid_amount && Number(value) === 0) {
          return t("paymentMethodIsRequired");
        }

        return "";

      case "full_address":
        if (orderType === 2 && !customerData?.full_address && !value) {
          return t("deliveryAddressIsRequired");
        }

        return "";

      default:
        return "";
    }
  };

  useEffect(() => {
    getAllCustomerConfigList()
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        setConfigList(decrypted);
      })
      .catch((err) => {
        notify.error(Utils.getErrorMessage(err));
      });
  }, []);

  const getEffectivePrice = (item) => {
    return item.custom_price !== null &&
      item.custom_price !== undefined &&
      item.custom_price !== ""
      ? Number(item.custom_price)
      : Number(item.selling_price || 0);
  };

  const calculateItemTotal = (item, qty, unit) => {
    if (!unit || !qty) return 0;

    const price = getEffectivePrice(item);

    const baseQty = Number(unit.unit_qty || 1);

    return Number(((qty * price) / baseQty).toFixed(2));
  };

  const getGrandTotal = (cart) => {
    return cart.reduce((sum, item) => {
      const qty = item.qty || 0;
      const unit =
        item.units?.find((u) => u.unit_id === item.unit_id) ||
        item.units?.find((u) => u.default_unit === 1) ||
        item.units?.[0];

      const autoTotal = calculateItemTotal(item, qty, unit);

      const finalTotal =
        item.manual_total !== null && item.manual_total !== undefined
          ? Number(item.manual_total)
          : (item.calculated_total ?? autoTotal);

      return sum + Number(finalTotal || 0);
    }, 0);
  };

  const totalPrice = getGrandTotal(cart);

  const getLatLngFromAddress = (address) => {
    if (!window.google) return;

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ address }, (results, status) => {
      if (status === "OK" && results[0]) {
        const location = results[0].geometry.location;

        const lat = location.lat();
        const lng = location.lng();

        setFormsData((prev) => ({
          ...prev,
          latitude: lat,
          longitude: lng,
        }));
      }
    });
  };

  const handlePlaceOrderModelOpen = () => {
    // if (!customerData?.full_address && orderType === 2) {
    //   if (!formsData.full_address) {
    //     notify.error("Delivery address is required.");
    //     setPlaceOrderModel(false);

    //     return;
    //   }
    // }

    // if (formsData.paid_amount) {
    //   if (!paymentmethod) {
    //     notify.error("Please choose a payment method.");
    //     setPlaceOrderModel(false);

    //     return;
    //   }
    // }
    const newErrors = {
      paid_amount: validateField(
        "paid_amount",
        formsData.paid_amount,
        totalPrice,
      ),

      payment_method: validateField(
        "payment_method",
        paymentmethod,
        totalPrice,
      ),

      full_address: validateField(
        "full_address",
        formsData.full_address,
        totalPrice,
      ),
    };
    Utils.focusError();
    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some((err) => err);

    if (hasErrors) return;

    setPlaceOrderModel(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setBtnLoading(true);

    const filterProduct = cart.map((item) => ({
      product_id: item.id,
      name: item.name,
      quantity: item.qty,
      unit_id: item.unit_id,
      unit: item.unit_short_name,
      total_price:
        item.manual_total === "" || item.manual_total == null
          ? item.calculated_total
          : Number(item.manual_total),
      total_original_price: item.calculated_total,
      price: item.custom_price ?? item.selling_price,
      unit_qty: item.unit_qty,
    }));

    const payload = {
      customer_id: customerData?.id,
      delivery_address: formsData?.full_address
        ? formsData?.full_address
        : customerData?.full_address,
      latitude: formsData?.latitude,
      longitude: formsData?.longitude,
      payment_method: paymentmethod || 0,
      order_type: orderType,
      items: filterProduct,
      total_amount: totalPrice,
      paid_amount: formsData?.paid_amount || 0,
    };

    try {
      const response = await createOrderStoreOwner(payload);
      const decrypted = decryptData(response.data.data);
      notify.success(decrypted.message);
      setCart([]);
      setOrderModel(false);
      setBtnLoading(false);
      setCustomerData("");
      setPlaceOrderModel(false);
    } catch (err) {
      setBtnLoading(false);
      notify.error(Utils.getErrorMessage(err));
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-screen bg-[#FDFCFB] dark:bg-[#050C1A] font-sans overflow-hidden transition-colors duration-300">
      <header className="bg-[#E67E22] p-5 flex items-center gap-4 shadow-lg hidden md:flex shrink-0">
        <button
          onClick={() => setOrderModel(false)}
          className="w-10 h-10 rounded-full bg-white dark:bg-slate-800 flex items-center justify-center text-slate-800 dark:text-white"
        >
          <ChevronLeft size={20} />
        </button>
        <h1 className="text-white font-black text-xl">{t("orderSummary")}</h1>
      </header>

      <main className="flex-1 overflow-y-auto scroll-smooth">
        {" "}
        <div className="max-w-[1400px] mx-auto p-4 md:p-10 pb-32">
          {" "}
          {/* Move padding here */}{" "}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            {" "}
            <div className="lg:col-span-5 space-y-6 lg:sticky lg:top-0">
              <div className="flex bg-slate-100 dark:bg-slate-900 p-1.5 rounded-2xl">
                {configList?.data?.order_type?.map((type) => (
                  <button
                    key={type.value}
                    onClick={() => setOrderType(type.value)}
                    className={`flex-1 py-3 rounded-xl font-bold text-sm transition-all ${
                      orderType === type.value
                        ? "bg-[#E67E22] text-white shadow-md"
                        : "text-slate-500 dark:text-slate-400"
                    }`}
                  >
                    {type.label}
                  </button>
                ))}
              </div>

              {orderType === 2 && (
                <div className="bg-white dark:bg-[#0A1221] rounded-3xl p-6 border border-slate-100 dark:border-slate-800 shadow-sm">
                  <label className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest block mb-3">
                    {t("deliveryAddress")}
                  </label>
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-orange-50 dark:bg-orange-950/20 rounded-lg text-[#E67E22] dark:text-orange-500">
                      <GeoAltFill />
                    </div>
                    {customerData?.full_address ? (
                      <p className="font-bold text-slate-700 dark:text-slate-300 text-sm">
                        {customerData.full_address}
                      </p>
                    ) : orderType === 1 ? (
                      <p className="font-bold text-slate-700 text-sm"></p>
                    ) : orderType === 2 ? (
                      <>
                        <div>
                          <div className="relative-group">
                            <textarea
                              type="text"
                              value={formsData.full_address}
                              name="full_address"
                              onChange={(e) =>
                                setFormsData({
                                  ...formsData,
                                  full_address: e.target.value,
                                })
                              }
                              onBlur={(e) =>
                                getLatLngFromAddress(e.target.value)
                              }
                              placeholder={t("enterDeliveryAddress")}
                              className={`input-field ${errors.full_address ? "input-error" : ""}`}
                              rows={3}
                            />
                          </div>
                          {errors.full_address && (
                            <span className={`text-danger mt-1`}>
                              {errors.full_address}
                            </span>
                          )}
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
              )}

              <div className="bg-white dark:bg-[#0A1221] rounded-3xl p-6 border border-slate-100 dark:border-slate-800 shadow-sm space-y-4">
                <h2 className="text-sm font-black text-zinc-900 dark:text-white uppercase tracking-widest">
                  {t("paymentStatus")}
                </h2>
                <div className="bg-zinc-100 dark:bg-slate-900 p-1 rounded-2xl flex items-center border dark:border-slate-800">
                  {configData?.payment_method
                    ?.filter((type) => Number(type.value) !== 3)
                    .map((type) => (
                      <button
                        key={type.value}
                        onClick={() => {
                          setPaymentMethod(type.value);

                          if (type.value === 0) {
                            setFormsData((prev) => ({
                              ...prev,
                              paid_amount: "",
                            }));
                          }
                        }}
                        className={`flex-1 py-2.5 rounded-[14px] text-xs font-black uppercase transition-all ${
                          paymentmethod === type.value
                            ? "bg-orange-500 text-white shadow-lg"
                            : "text-zinc-500 dark:text-slate-400"
                        }`}
                      >
                        {type.label}
                      </button>
                    ))}
                </div>
                {errors.payment_method && (
                  <span className={`text-danger mt-1`}>
                    {errors.payment_method}
                  </span>
                )}

                {paymentmethod !== 0 && (
                  <div className="pt-4 border-t dark:border-slate-800 mt-4">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-3">
                      {t("paidAmount")}
                    </label>
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-orange-50 dark:bg-orange-950/20 rounded-lg text-[#E67E22]">
                        <CurrencyRupee />
                      </div>
                      <input
                        type="text"
                        inputMode="decimal"
                        value={formsData.paid_amount}
                        onChange={(e) => {
                          let value = e.target.value;
                          if (!/^\d*\.?\d*$/.test(value)) return;
                          if (value.length > 6) return;
                          if (
                            value &&
                            !value.endsWith(".") &&
                            Number(value) < 1
                          )
                            return;
                          setFormsData({
                            ...formsData,
                            paid_amount: value,
                          });
                        }}
                        className="w-full p-4 bg-gray-50 dark:bg-[#050C1A] border-2 border-gray-100 dark:border-slate-800 rounded-2xl outline-none font-bold dark:text-white"
                        placeholder={t("enterPaidAmount")}
                      />
                    </div>

                    {errors.paid_amount && (
                      <span className={`text-danger mt-1`}>
                        {errors.paid_amount}
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="lg:col-span-7 h-full flex flex-col">
              <div className="bg-white dark:bg-[#0A1221] rounded-[2.5rem] p-6 shadow-sm border border-slate-50 dark:border-slate-800 flex-1 overflow-hidden flex flex-col">
                <div className="flex items-center justify-between mb-6 px-2 shrink-0">
                  <h3 className="text-xs font-black text-slate-400 uppercase tracking-widest">
                    {t("itemsInCart")}
                  </h3>
                  <span className="bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 px-3 py-1 rounded-full text-[10px] font-black">
                    {cart?.length} {t("items")}
                  </span>
                </div>
                {/* Set a max-height and overflow-y-auto to create the internal scroll */}
                <div className="flex-1 pr-2 space-y-4 pb-32 scroll-smooth">
                  {cart?.length === 0 ? (
                    <div className="flex justify-center mt-10">
                      <button
                        onClick={() => setOrderModel(false)}
                        className="px-6 py-3 bg-orange-500 text-white font-bold rounded-xl hover:bg-orange-600 transition"
                      >
                        {t("selectOtherItem")}
                      </button>
                    </div>
                  ) : (
                    cart?.map((item) => {
                      const price = Number(
                        item.manual_total ??
                          item.calculated_total ??
                          item.selling_price ??
                          0,
                      );

                      return (
                        <div
                          key={`${item.id}-${item.unit_id}`}
                          className="relative bg-white dark:bg-slate-900 border border-zinc-100 dark:border-slate-800 p-5 rounded-[2.5rem] shadow-sm"
                        >
                          {/* Subtle Orange Accent Circle (Top Right) */}
                          <div className="absolute -top-4 -right-4 w-16 h-16 bg-orange-50 dark:bg-orange-900/20 rounded-full opacity-50" />

                          <div className="flex gap-4 relative z-10">
                            {/* Box Image Container */}
                            <div className="w-20 h-20 bg-slate-50 dark:bg-slate-800 rounded-3xl flex items-center justify-center shrink-0 border border-slate-100 dark:border-slate-700">
                              <span className="text-3xl">
                                {item?.icon || "📦"}
                              </span>
                            </div>

                            {/* Product Details */}
                            <div className="flex-1">
                              <div className="flex justify-between items-start">
                                <h4 className="text-xl font-black text-slate-800 dark:text-white leading-tight">
                                  {item.name}
                                </h4>
                              </div>

                              <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-1">
                                {t("packing")}: {item.name.toUpperCase()} (
                                {item.unit_qty} {item.unit_short_name})
                              </p>

                              <div className="grid grid-cols-2 gap-2 mt-6 pt-2 border-t border-dashed border-slate-100 dark:border-slate-800">
                                <div>
                                  <p className="text-[9px] font-black text-slate-400 uppercase tracking-tighter">
                                    {t("unitPrice")}
                                  </p>
                                  <p className="text-sm font-bold text-slate-600 dark:text-slate-300">
                                    {formatCurrencyINR(
                                      item.custom_price ?? item.selling_price,
                                    )}
                                  </p>
                                </div>
                                <div className="text-right">
                                  <p className="text-[9px] font-black text-orange-500 uppercase tracking-tighter">
                                    {t("productTotal")}
                                  </p>
                                  <p className="text-lg font-black text-slate-900 dark:text-white">
                                    {formatCurrencyINR(price)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>

                {/* Subtotal Section */}
                <div className="mt-8 pt-6 border-t-2 border-dashed border-slate-100 dark:border-slate-800 flex justify-between items-center">
                  <span className="text-lg font-bold">{t("total")}:</span>
                  <span className="text-3xl font-black text-[#E67E22]">
                    {formatCurrencyINR(totalPrice)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      {cart?.length > 0 && (
        <div className="fixed bottom-0 left-0 right-0 p-6 z-50">
          {/* Glassmorphism background effect */}
          <div className="absolute inset-0 bg-gradient-to-t dark:from-[#0A1221] dark:via-[#0A1221]/80 -z-10" />

          <div className="max-w-[1400px] mx-auto flex justify-center">
            <button
              type="button"
              onClick={handlePlaceOrderModelOpen}
              disabled={btnLoading}
              className={`w-full md:max-w-lg py-5 px-10 rounded-[2rem] font-black uppercase tracking-[0.2em] text-sm shadow-[0_20px_50px_rgba(230,126,34,0.3)] transition-all active:scale-95 flex items-center justify-center gap-4 ${
                btnLoading
                  ? "bg-slate-200 text-slate-400"
                  : "bg-[#E67E22] text-white hover:bg-orange-600 hover:-translate-y-1"
              }`}
            >
              {btnLoading ? (
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                t("placeOrder")
              )}
            </button>
          </div>
        </div>
      )}
      {placeOrderModel && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="bg-white dark:bg-[#161e2d] rounded-3xl p-6 w-[90%] max-w-sm shadow-2xl animate-fade-in">
            <h2 className="text-lg font-bold text-gray-800 dark:text-white mb-2">
              {t("confirmPlaceOrder")}
            </h2>

            <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
              {t("placeOrderDescription")}
            </p>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setPlaceOrderModel(false)}
                className="px-4 py-2 rounded-xl bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-200 font-semibold hover:bg-gray-200 transition"
              >
                {t("cancel")}
              </button>

              <button
                onClick={handleSubmit}
                disabled={btnLoading}
                className={`px-4 py-2 rounded-xl font-semibold transition flex items-center justify-center gap-2
    ${
      btnLoading
        ? "bg-red-400 cursor-not-allowed"
        : "bg-red-500 hover:bg-red-600 text-white"
    }`}
              >
                {btnLoading ? (
                  <>
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                    {t("placingOrder")}
                  </>
                ) : (
                  t("yesPlaceOrder")
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StoreOwnerOrderSummary;
